import Input from './Input';
import Button from './Button';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme) {
  return {
    ...Input(theme),
    ...Button(theme)
  };
}
